import { stegaClean } from "@sanity/client/stega";

// SEE: https://www.sanity.io/docs/visual-editing/troubleshooting-visual-editing#cbba7d61d43c
export const sanitizeString = (str: string) => {
  // sanitize non ASCII chars
  return stegaClean(str);
};
